module.exports = __webpack_public_path__ + "static/media/mapa-eng-phone.8b525142.svg";